<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :data="model"
                   :title="$t(`Email Notification Setup Modal`)"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   :content-in-form="false"
                   scrollable size="lg"
                   ref="templatesToEmailsModal">
      <div>
        <customer-emails-tiers :model="model"></customer-emails-tiers>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import CustomerSelectInputWidget from "../../../../core/widgets/CustomerSelectInputWidget";
  import InputWidget from "../../../../core/components/input-widget/InputWidget";
  import ArtisioModal from "../../../../core/components/artisio-modal/ArtisioModal";
  import TemplateTypeSelectInputWidget from "../../../../core/widgets/TemplateTypeSelectInputWidget";
  import CustomerEmailsTiers from "../../../../core/components/templates-to-emails-tiers/TemplatesToEmailsTiers";
  import TemplatesToEmailsModel
    from "../../../../core/components/templates-to-emails-tiers/TemplatesToEmails.model";
  import TemplatesToEmailsTiersModel from "../../models/TemplatesToEmailsTiers.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "TemplatesToEmailsModal",
    components: {
      CustomerEmailsTiers,
      CustomerSelectInputWidget, InputWidget, ArtisioModal, TemplateTypeSelectInputWidget
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new TemplatesToEmailsTiersModel(),
        tiers: []
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        modal: state => state.templatesToEmailsModal,
      }),
    },
    methods: {
      ...mapActions(['hideTemplatesToEmailsModal', 'updateCustomerEmailsToTemplates']),
      onShow() {
        this.showConfirmation = true;
        this.modal.items.forEach(item =>
          this.model.tiers.push(new TemplatesToEmailsModel(item))
        );
        if (this.model.tiers.length === 0) {
          this.model.tiers.push(new TemplatesToEmailsModel({uuid: null, template_type: null, emails: []}))
        }
        this.$refs.templatesToEmailsModal.updateOldState();
      },
      onHidden() {
        this.model = new TemplatesToEmailsTiersModel();
        this.hideTemplatesToEmailsModal();
      },
      async onSubmit() {
        this.loading = true;
        let response = await this.updateCustomerEmailsToTemplates(this.model.tiers);
        this.loading = false;
        if (response.success) {
          this.showConfirmation = false;
          await this.hideTemplatesToEmailsModal();
          this.$toast('success', this.$t('Email Notification Setup was updated successfully'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else if (response.body.errors) {
            const listItemsArr = [];
            response.body.errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
